<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Sites"
};
</script>

<style scoped>
</style>
